<template>
 <div>
  <div class="page_content page_content_reg">
    <div class="change_password_content">
      <div class="change_password_content_title">需求方注册</div>
      <div class="change_password_content_form_wrap">
        <el-form ref="ruleForm" :model="ruleForm" status-icon label-width="100px" class="demo-ruleForm" >
          <el-form-item label="真实姓名" prop="name" :rules="[
          { required: true, message: '请输入真实姓名'},
        ]">
            <el-input placeholder="真实姓名" style="width: 336px;" type="text" v-model="ruleForm.name"
              autocomplete="off" maxLength="30"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="userName" :rules="[
          {required: true,  validator: checkUserName, trigger: 'blur'},
        ]">
            <el-input placeholder="用户名(推荐输入真实姓名的拼音)" style="width: 336px;" type="text" v-model="ruleForm.userName"
              autocomplete="off" maxLength="30"></el-input>
          </el-form-item>
          <el-form-item :rules="[
          { required: true, message: '请输入密码'},
        ]" label="密码" prop="pass">
            <el-input placeholder="6-16位英文和数字，区分大小写" style="width: 336px;" type="password" v-model="ruleForm.pass"
              autocomplete="off" maxLength="16"></el-input>
          </el-form-item>
          <el-form-item :rules="[
          { required: true, validator: checkPass, trigger: 'blur'},
        ]" label="确认密码" prop="checkPass">
            <el-input placeholder="确认密码" style="width: 336px;" type="password" v-model="ruleForm.checkPass"
              autocomplete="off" maxLength="16"></el-input>
          </el-form-item>
          <el-form-item :rules="[
          { required: true, message: '请输入公司名称'},
        ]" label="公司名称" prop="company">
            <el-input placeholder="公司名称" style="width: 336px;" type="text" v-model="ruleForm.company"
              autocomplete="off" maxLength="50"></el-input>
          </el-form-item>
          <el-form-item :rules="[
          { required: true, message: '请输入邮箱'},
          {type:'email',message: '请输入正确的邮箱地址'}
        ]" label="邮箱" prop="email">
            <el-input placeholder="邮箱" style="width: 336px;" type="text" v-model="ruleForm.email"
              autocomplete="off"   maxLength="40"></el-input>
          </el-form-item>
          <el-form-item :rules="[
          { required: true, validator: checkPhone, trigger: 'blur'}
        ]" label="手机号" prop="telphone">
            <el-input placeholder="11位手机号" style="width: 336px;" type="text" v-model="ruleForm.telphone"
              autocomplete="off"  maxLength="11">
              <template slot="prepend">+86</template>
            </el-input>
          </el-form-item>
          <el-form-item label="滑动验证">
            <SlideVerify ref="slideVerify" width="336px" @passed="onSlidePassed" />
          </el-form-item>
          <el-form-item :rules="[
          { required: true, message: '请输入验证码'},
        ]" label="验证码" prop="code">
            <el-input placeholder="请输入验证码" style="width: 336px;" type="text" v-model="ruleForm.code"
              autocomplete="off"   maxLength="10">
              <template slot="append">
                <div class="brand_register_code_btn" @click="getyzm" :disabled="disabled">{{ titlename }}</div>
              </template>

            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button style="height: 40px;padding: 8px 152px;" type="primary"
              @click="submitForm('ruleForm')" :disabled="form_disabled">注册</el-button>
              <div style="text-align: center;width: 334px;">
                <!-- <el-button  type="text">使用已有账号登录</el-button> -->
              </div>
          </el-form-item>
        </el-form>

      </div>
    </div>
  </div>

 </div>
</template>
<script>
/* eslint-disable */
import * as commfun from "@/common/common.js"
import axios from "axios"
import SlideVerify from "@/components/SlideVerify.vue"
export default {
  name: 'Reg',
  data() {
    return {
        dialogVisible: false,
        checked: true,
        ruleForm: {
          name: '',
          userName: '',
          pass: '',
          checkPass: '',
          company: '',
          email: '',
          telphone: '',
          code: '',
        },
        second: '', // 倒计时秒
        disabled: false, //倒计时停用按钮
        timer: null, //计时器
        yzm: '', //验证码
        form_disabled: false,
        slidePassed: false,
        slideToken: ''
      };
  },
  components: { SlideVerify },
  computed: {
      titlename() {
        return this.disabled ? this.second + "s" : '获取验证码';
      }
    },
  methods: {
    checkPhone(rule, value, callback) {
      if (value === '') {
          callback(new Error('手机号码不能为空'));
        } else if (!this.alidatePhone(value)) {
          callback(new Error('手机号码不正确'));
        } else {
          callback();
        }
    },
    checkUserName(rule, value, callback) {
      if (value === '') {
          callback(new Error('请再次用户名'));
        } else if (!this.alidateInputUserName(value)) {
          callback(new Error('用户名仅支持输入英文字母和数字，限制输入最多30个字符'));
        } else {
          callback();
        }
    },
    checkPass(rule, value, callback) {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.pass) {
          callback(new Error('两次输入密码不一致!'));
        } else if (!this.alidateInput(value)) {
          callback(new Error('密码仅支持输入英文字母和数字，限制输入6-16字符'));
        } else {
          callback();
        }
      },
      onSlidePassed (token) {
        this.slidePassed = true
        this.slideToken = token
      },
      alidatePhone(textInput) {
        let regex = /^1[3456789]\d{9}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      alidateInputUserName(textInput) {
        let regex = /^[a-zA-Z0-9]{1,30}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      //判断新密码仅支持输入英文字母和数字，限制输入6-16字符
      alidateInput(textInput) {
        let regex = /^[a-zA-Z0-9]{6,16}$/;
        if (!regex.test(textInput)) {
          return false;
        }
        return true;
      },
      getyzm: function () {
        let selfthis = this
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        if (!selfthis.slideToken) {
          commfun.showMessage(selfthis, 'warning', '滑块凭证异常，请刷新重试')
          return false;
        }
        if (!selfthis.ruleForm.telphone) {
          commfun.showMessage(selfthis, 'warning', '请输入手机号码!')
          return false;
        }
        selfthis.sendSms(selfthis,selfthis.ruleForm.telphone);
        // 倒计时 控制start
        let s = 60 // 倒计时 1分钟
        if (!selfthis.timer) {
          console.log('--start--')
          selfthis.second = s
          selfthis.disabled = true
          selfthis.timer = setInterval(() => {
            if (selfthis.second > 0 && selfthis.second <= s) {
              selfthis.second--
            } else {
              selfthis.disabled = false
              clearInterval(selfthis.timer)
              selfthis.timer = null
            }
          }, 1000)
        }
        // 倒计时 控制end

      },
      sendSms: function (selfthis,telphone) {
        if(selfthis.disabled == true){
          console.log("倒计时还没完成")
          return false
        }
        // var url = "/api/site/sendsms2?phone="+this.telphone+"&sys_type=biginhouse&type=index_inhouse"
        var url = "/api/api/login/sendsms"
        var postdata = {phone:telphone, slide_token: selfthis.slideToken}
        commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
          console.log(data)
          commfun.showMessage(selfthis, 'success', "成功：" + "短信发送成功")
          return true
        }, function (selfthis, dataError) {
          selfthis.disabled = false
          commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
        })


      },
      submitForm(formName) {
        var selfthis = this
        if (!selfthis.slidePassed) {
          commfun.showMessage(selfthis, 'warning', '请先完成滑动验证')
          return false;
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var url = '/api/api/login/toreg'
            selfthis.form_disabled = true
            var postdata = selfthis.ruleForm
            commfun.ajaxPost(selfthis, url, postdata, function (selfthis, data) {
              console.log(data)
              commfun.showMessage(selfthis, 'success', "注册成功！请等待审核通过后登录。")
              setTimeout(function () {
                window.location.href = "/"
              }, 100)
              return true
            }, function (selfthis, dataError) {
              selfthis.form_disabled = false
              commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
            })

          } else {
            selfthis.form_disabled = false
            //commfun.showMessage(selfthis, 'warning', "错误：" + dataError.msg)
            return false;
          }
        });

      },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/Reg.vue